export default {
  GET_ALL_FREQUENCY (state, data) {
    state.all_frequency = data.data
  }
}
